module.exports = __webpack_public_path__ + "img/pingdingshan.52d84c54.png";